module.exports = __webpack_public_path__ + "img/lg_ring_0_0_0_null@2x.ca321ddd.png";